import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCWX7LdhRnGliJ_DFDCU5cLt0Tj10H1oR0",
  authDomain: "remi-dashboard.firebaseapp.com",
  projectId: "remi-dashboard",
  storageBucket: "remi-dashboard.firebasestorage.app",
  messagingSenderId: "891071932417",
  appId: "1:891071932417:web:d9967f0c03ea71424bb800"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);